export const components = {
  emptyState: {
    primaryTitle: 'Hoppsan!',
    primaryText: 'Inget här ännu…',
    secondaryTitle: 'Inget att visa',
    secondaryText: 'Tyvärr finns det inga element att visa baserat på tillämpade filter…'
  },
  filters: {
    all: 'Alla',
    search: 'Sök',
    priceRange: 'Prisintervall {currency}',
    minValue: 'Det minsta värdet är {val}!',
    maxValue: 'Det högsta värdet är {val}!',
    reset: 'Återställ',
    apply: 'Tillämpa'
  },
  comments: {
    reply: 'Svara',
    loadMore: 'Ladda mer',
    edited: 'Redigerad',
    noComments: 'Det finns inga kommentarer ännu',
    leaveFirstComment: 'Du kan lämna den första'
  },
  curtain: {
    close: 'Stäng'
  },
  photoPreview: {
    close: 'Stäng'
  },
  photoCropper: {
    back: 'Tillbaka',
    save: 'Spara'
  },
  rightSidebar: {
    in: 'i'
  },
  pushPrompt: {
    title: '“{appName}” skulle vilja skicka dig aviseringar',
    description: 'Aviseringar kan inkludera varningar, ljud och ikonmarkeringar. Dessa kan konfigureras i Inställningar.',
    later: 'Fråga mig senare',
    neverLater: 'Fråga inte igen',
    allow: 'Tillåt'
  },
  inAppPush: {
    attachment: 'Bilaga'
  },
  installPrompt: {
    android: {
      install: 'Installera',
      description: 'För en sömlös upplevelse behöver du inte använda en webbläsare. Installera det bara som en app.',
      press: 'Tryck',
      andSelect: 'och välj',
      orSimply: 'eller helt enkelt',
      description2: 'klicka på Installera-knappen nedan',
      notNow: 'Inte nu'
    },
    ios: {
      justTap: 'Tryck på',
      buttonInBrowser: '"Mer"-knappen i din webbläsare och välj "Dela"',
      addToHomeScreen: 'Scrolla ner och tryck på "Lägg till på hemskärmen", klicka sedan på "Lägg till"',
      appWillBeInstalled: 'Appen läggs till på din hemskärm'
    },
    installApp: 'Installera appen',
    useWeb: 'Använd webbversion'
  },
  footer: {
    more: 'Meny'
  },
  menu: {
    installApp: 'Installera app',
    menu: 'Meny',
    close: 'Stäng'
  },
  404: {
    whoops: 'Hoppsan!',
    description:
      'Det verkar som att sidan inte existerar eller så har du inte åtkomst till den. Vänligen kontakta appens ägare för mer information.',
    ok: 'OK'
  },
  relatedUsers: {
    seeall: 'Se alla'
  },
  networkingCurtain: {
    'newOneOnOne': 'Ny 1:1',
    'details': 'Detaljer',
    'coverMessage': 'Cover-meddelande',
    'location': 'Plats',
    'duration': 'Varaktighet',
    '15min': '15 min',
    '30min': '30 min',
    '45min': '45 min',
    '60min': '60 min',
    'timeSlot': 'Tidsintervall',
    'sendInvitation': 'Skicka inbjudan',
    'success': 'Framgång',
    'invitationSent':
      'Du har framgångsrikt skickat inbjudan till ett 1:1 möte. Vill du stanna på denna sida eller gå till alla dina schemalagda 1:1 möten?',
    'seeAll': 'Se alla 1:1 möten',
    'stayHere': 'Stanna här'
  },
  networking: {
    level: {
      1: 'Inte redo att nätverka än. Ingen betydande aktivitet eller engagemang.',
      2: 'Sällan aktiv eller saknar viktiga profiluppgifter, vilket gör det svårt för andra att koppla ihop sig.',
      3: 'Profilen är komplett med foto och online, helt redo att börja nätverka.',
      4: 'Bygger momentum - har initierat minst en anslutning under de senaste 6 timmarna.',
      5: 'En nätverksmästare - svarar aktivt på förfrågningar och engagerar sig med andra under de senaste 6 timmarna.'
    }
  },
  time: {
    days: 'd',
    hours: 'h',
    minutes: 'm',
    seconds: 's',
    startsIn: 'om',
    Today: 'Idag',
    today: 'idag',
    Tomorrow: 'Imorgon',
    tomorrow: 'imorgon',
    Yesterday: 'Igår',
    yesterday: 'igår',
    startingNow: 'startar nu'
  },
  daysMonths: {
    months: "['Januari','Februari','Mars','April','Maj','Juni','Juli','Augusti','September','Oktober','November','December']",
    monthsShort: "['Jan', 'Feb', 'Mar', 'Apr', 'Maj', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec']",
    weekdays: "['Söndag', 'Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag']",
    weekdaysShort: "['Sön', 'Mån', 'Tis', 'Ons', 'Tor', 'Fre', 'Lör']",
    weekdaysMin: "['Sö', 'Må', 'Ti', 'On', 'To', 'Fr', 'Lö']"
  },
  badges: {
    legend: 'Legendary Networker',
    push: 'Online and Trusted',
    leader: 'Leaderboard Champ',
    meetmaster: '1:1 Meeting Master',
    connector: '3-Time Connector',
    legend_description: 'Uppnå Legend-nivån minst en gång genom att aktivt nätverka och skapa meningsfulla kopplingar.',
    push_description: 'Aktivera push-notifikationer för att alltid vara responsiv och aldrig missa en möjlighet.',
    leader_description: 'Kom åtminstone en gång in i topp 10 % på leaderboardet.',
    meetmaster_description: 'Starta eller svara på minst en 1:1 mötesförfrågan i appen.',
    connector_description: 'Skapa minst tre kopplingar genom appen under komponenterna.'
  }
}
